import { ChannelResolver, ChannelResolveParams } from 'core/repositories/ChannelResolver';
import { MediaDeviceApiCall } from '../api/MediaDevice';
import { MediaDeviceRepository } from 'core/repositories/MediaDeviceRepository';
import { T4APIChannel } from './Channel';
import { MultiplexedChannel } from './MultiplexedChannel';
import { CompanionChannel } from './CompanionChannel';

function hasUseSubChannels(x: Record<string, unknown>): x is { subChannels: number } {
    return 'subChannels' in x;
}

class ChannelResolverImpl implements ChannelResolver {
    private apiCall: MediaDeviceApiCall;
    private mediaDeviceRepository: MediaDeviceRepository;

    constructor(apiCall: MediaDeviceApiCall, mediaDeviceRepository: MediaDeviceRepository) {
        this.apiCall = apiCall;
        this.mediaDeviceRepository = mediaDeviceRepository;
    }

    async resolve(params: ChannelResolveParams) {
        const { vehicle, projectId, environmentId } = params;
        const subChannels = hasUseSubChannels(params) ? params.subChannels : 0;
        const cameras = new Map(vehicle.cameras.map(e => [
            e.tag,
            (() => {
                const mainChannel = new T4APIChannel(e, projectId, environmentId, this.apiCall, this.mediaDeviceRepository);
                return subChannels > 0 ?
                    new MultiplexedChannel([
                        mainChannel,
                        ...[...Array(subChannels)].map((_, i) => new CompanionChannel(mainChannel, i + 1))
                    ])
                    : mainChannel;
            })()
        ]));
        const microphones = new Map(vehicle.microphones.map(e => [
            e.tag,
            new T4APIChannel(e, projectId, environmentId, this.apiCall, this.mediaDeviceRepository),
        ]));
        return { cameras, microphones };
    }
}

export { ChannelResolverImpl as ChannelResolver };
